import { render, staticRenderFns } from "./SlideNavigation.vue?vue&type=template&id=21762ba6&lang=pug"
import script from "./SlideNavigation.vue?vue&type=script&lang=ts"
export * from "./SlideNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports